var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"dragged",rawName:"v-dragged",value:(_vm.onDragged),expression:"onDragged"}],staticClass:"playhead",class:{ 'is-dragging': _vm.isDragging },on:{"dragstart":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"drag-area"})])
}
var staticRenderFns = []

export { render, staticRenderFns }